import { text_colorTextSecondary } from 'ext-ui/style/colors'
import AiStarsIcon from 'ext-ui/svg/icon/AiStarsIcon'
import MccFinancialIcon from 'ext-ui/svg/icon/MccFinancialIcon'
import MccGasIcon from 'ext-ui/svg/icon/MccGasIcon'
import MccRestaurantsIcon from 'ext-ui/svg/icon/MccRestaurantsIcon'
import MccTransportationIcon from 'ext-ui/svg/icon/MccTransportationIcon'
import React from 'react'
import { useTranslate } from 'src/localization/Trns'

import styles from './ExpensePolicyChatEmptyState.style'

interface ExpensePolicyChatEmptyStateProps {
  onPromptClick: (prompt: string) => void
}

const ExpensePolicyChatEmptyState: React.FC<
  ExpensePolicyChatEmptyStateProps
> = ({ onPromptClick }) => {
  const translate = useTranslate()

  const prompts = [
    {
      title: translate('What is the policy on meals and entertainment?'),
      icon: (
        <MccRestaurantsIcon
          width={16}
          height={16}
          color={text_colorTextSecondary}
        />
      ),
      prompt: 'What is the policy on meals and entertainment?',
    },
    {
      title: translate('What does my policy say about transportation?'),
      icon: (
        <MccTransportationIcon
          width={16}
          height={16}
          color={text_colorTextSecondary}
        />
      ),
      prompt: 'What does my policy say about transportation?',
    },
    {
      title: translate('Can I expense gas while traveling for work?'),
      icon: (
        <MccGasIcon width={16} height={16} color={text_colorTextSecondary} />
      ),
      prompt: 'Can I expense gas while traveling for work?',
    },
    {
      title: translate(
        'How much am I allowed to spend per day at the offsite?',
      ),
      icon: (
        <MccFinancialIcon
          width={16}
          height={16}
          color={text_colorTextSecondary}
        />
      ),
      prompt: 'How much am I allowed to spend per day at the offsite?',
    },
  ]

  return (
    <div css={styles} className="ExpensePolicyChatEmptyState">
      <div className="icon">
        <AiStarsIcon />
      </div>
      <div className="empty-state-title">
        {translate('How can I help you?')}
      </div>
      <div className="empty-state-subtitle">
        {translate('Ask me anything about your expense policy')}
      </div>
      <div className="prompts-list">
        {prompts.map((prompt, index) => (
          <button
            className={'prompt-button'}
            key={index}
            onClick={() => onPromptClick(prompt.prompt)}
          >
            <div className={'prompt-button-icon'}>{prompt.icon}</div>
            {prompt.title}
          </button>
        ))}
      </div>
    </div>
  )
}

export default ExpensePolicyChatEmptyState
